import React, { Dispatch } from "react";
import { ActionType } from "./types";
import { GetHomeDto } from "../../services/Home/dto/get.dto";
import { UpdateStatusParams } from "./usecase.d";

export type HomeStateType = {
  data: Array<GetHomeDto>;
};

export type HomeActionType = {
  type: symbol;
  items?: GetHomeDto[];
  addedItem?: GetHomeDto;
  updatedItem?: GetHomeDto;
  deleteId?: string;
  updatedStatusItem?: UpdateStatusParams;
};

type HomeReducerType = React.Reducer<HomeStateType, HomeActionType>;

export type HomeDispatch = Dispatch<HomeActionType>;

const initialGetState: HomeStateType = {
  data: new Array<GetHomeDto>(),
};

interface TransformUpdateDataParams {
  originalData: Array<GetHomeDto>;
  updatedData: GetHomeDto;
}

function transformUpdateData({
  originalData,
  updatedData,
}: TransformUpdateDataParams) {
  return originalData.map((item) => {
    if (item.id === updatedData.id) {
      return updatedData;
    }
    return item;
  });
}

interface TransformUpdateStatusParams {
  originalData: Array<GetHomeDto>;
  updatedData: UpdateStatusParams;
}

function transformUpdateStatusData({
  originalData,
  updatedData,
}: TransformUpdateStatusParams) {
  return originalData.map((item) => {
    const newItem = { ...item };
    if (item.id === updatedData.id) {
      newItem.isActive = updatedData.isActive;
      return newItem;
    }
    return newItem;
  });
}

interface TransformDeleteParams {
  originalData: Array<GetHomeDto>;
  deleteId: string;
}

function transformDeleteData({
  originalData,
  deleteId,
}: TransformDeleteParams) {
  return originalData.filter((item) => item.id !== deleteId);
}

export const Reducer: HomeReducerType = (state = initialGetState, action) => {
  switch (action.type) {
    case ActionType.GetList:
      return {
        data: action.items || [],
      };
    case ActionType.Create:
      if (!action.addedItem) {
        throw new Error("Added item does not exists");
      }
      return {
        data: [...state.data, action.addedItem],
      };
    case ActionType.Update:
      if (!action.updatedItem) {
        throw new Error("Updated item does not exists");
      }
      return {
        data: transformUpdateData({
          originalData: state.data,
          updatedData: action.updatedItem,
        }),
      };
    case ActionType.UpdateStatus:
      if (!action.updatedStatusItem) {
        throw new Error("Updated item does not exists");
      }
      return {
        data: transformUpdateStatusData({
          originalData: state.data,
          updatedData: action.updatedStatusItem,
        }),
      };
    case ActionType.Delete:
      if (!action.deleteId) {
        throw new Error("Delete Id does not exists");
      }
      return {
        data: transformDeleteData({
          originalData: state.data,
          deleteId: action.deleteId,
        }),
      };
    default:
      return state;
  }
};
